


























import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { SchoolClass } from '@/models/school-class/school-class';
import GJgrowEventCreateExamineeStudentTable from '@/views/GJgrowEventCreate/ExamineeSetting/GJgrowEventCreateExamineeStudentTable.vue';
import { Student } from '@/models/student/student';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';

@Component({
  name: 'GExamCreateExamineeSettingStudents',
  components: { GJgrowEventCreateExamineeStudentTable },
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateExamineeSettingStudents extends Mixins(GPageBase) {
  grade: number = 0;
  schoolClassID: number = 0;
  fileExcelName: string = '';
  excelFile: File = undefined;

  async mounted() {
    if (this.grades.length > 0) {
      this.grade = this.grades[0];
    }
    this.schoolClassID = this.refreshSchoolClassModel(this.schoolClasses, this.grade);
  }

  handleSelectFile(fileExcel: File): void {
    this.fileExcelName = fileExcel.name;
    this.excelFile = fileExcel;
    this.handleExcelUpload();
  }

  get grades(): number[] {
    return schoolClassModule.grades;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  handleExcelUpload(): boolean {
    if (!this.excelFile) {
      this.showNotice(GEnum.MessageType.Warn, 'Empty Error!', 'Please choose and Excel file with .xl or .xlxs extension.', 3);
      return false;
    }
    let requiredFormat: any = ['xls', 'xlsx'];
    let fileExt = this.excelFile.name.split('.').pop();
    if (!requiredFormat.includes(fileExt)) {
      this.showNotice(GEnum.MessageType.Warn, 'エクセルファイルを指定してください', '', 3);
      return false;
    }
    this.isRunning = true;
    let formData = new FormData();
    formData.append('file', this.excelFile);
    jgrowEventCreateModule.loadStudents(formData).then(response => {
      this.isRunning = false;
    });
  }

  handleCleanStudents() {
    jgrowEventCreateModule.setExamineeStudents([]);
  }

  get targetSelectedStudentCount(): number {
    if (jgrowEventCreateModule.jgrowEventPageModeEdit) {
      return jgrowEventCreateModule.plusExamineeStudents.length;
    } else {
      return jgrowEventCreateModule.assignedExamineeStudents.length;
    }
  }

  get examineeStudents(): Student[] {
    return jgrowEventCreateModule.examineeStudents;
  }

  get evalSettingModeEdit(): boolean {
    return jgrowEventCreateModule.jgrowEventPageModeEdit;
  }
}
